import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { CustomButtonComponent } from "../../../../../shared/components/custom-button/custom-button.component";
import { AddMissingDataComponent } from "../../../dialogs/add-missing-data/add-missing-data.component";
import { ToastComponent } from '../../../../../shared/components/toast/toast.component';

@Component({
  selector: 'app-complete-energy-profile',
  standalone: true,
  imports: [CommonModule, TranslocoPipe, CustomButtonComponent, AddMissingDataComponent, ToastComponent],
  templateUrl: './complete-energy-profile.component.html',
  styleUrl: './complete-energy-profile.component.css'
})
export class CompleteEnergyProfileComponent {
  private _showPopup = true;

  @ViewChild(ToastComponent) toast!: ToastComponent;
  @ViewChild(AddMissingDataComponent) missingDataDialog!: AddMissingDataComponent;

  @Input()
  get showPopup(): boolean {
    return this._showPopup;
  }

  set showPopup(value: boolean) {
    this._showPopup = value;
  }

  @Output() showPopupChange = new EventEmitter<boolean>();
  constructor(private cdr: ChangeDetectorRef) {}

  ngAfterViewInit(): void {
    this.cdr.detectChanges();
  }

  updateShowPopup(newValue: boolean) {
    this._showPopup = newValue;
    this.showPopupChange.emit(this._showPopup);
  }

  onAddDataClick() {
    this.missingDataDialog.openModal();
  }
}
